export const ModuleTags = {
  PatientNotes: 'PatientNotes',
  UnreadNotifications: 'UnreadNotifications',
  GrinNotificationsList: 'GrinNotificationsList',
  PracticeTeamMembers: 'PracticeTeamMembers',
  CopilotControlMetabase: 'CopilotControlMetabase',
  PracticeGuidelines: 'PracticeGuidelines',
  ScanTagging: 'ScanTagging',
  CopilotNeedsAttention: 'CopilotNeedsAttention',
  CopilotControlSentiment: 'CopilotControlSentiment',
  PatientCopilot: 'PatientCopilot',
  CopilotSchedulingScore: 'CopilotSchedulingScore',
  OralHygieneAggregation: 'OralHygieneAggregation',
  TxTrackingAggregation: 'TxTrackingAggregation'
}
